import ConfigContext, { Config } from './ConfigContext';
import React, { PropsWithChildren, useEffect, useState } from 'react';

export const ConfigContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [config, setConfig] = useState<Config>();

	useEffect(() => {
		async function loadConfig() {
			const r = await fetch('/config.json');
			const c = (await r.json()) as Config;
			setConfig(c);
		}
		loadConfig();
	}, []);

	if (!config) {
		return null;
	}
	return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export default ConfigContextProvider;
